import { SORT_TYPE } from '@app/constants/commonConstants';

export const ORDERS_TO_APPROVE = 'ordersApprove';
export const PAGE_LIMIT = 12;
export const FIRST_PAGE = 1;

export const ORDER_STATUS = [
  { label: 'CAT_ORD_ALL', value: '' },
  { label: 'MO_OrderStatus_P', value: '0' },
  { label: 'ORG_STATUS_APPROVED', value: '1' },
  { label: 'CAT_ORD_REJECTED', value: '2' },
  { label: 'CAT_ORD_DELETED', value: '3' },
  { label: 'EXPIRED_STATE', value: '4' }
];

export const ORDERS_TO_APPROVE_SEARCH_FORM_FIELDS = {
  ORDER_NUMBER: 'orderNumber',
  MO_PURCHASEORDER: 'poNumber',
  DCN: 'dcn',
  DISPLAY_ORDER_STATUS: 'orderStatus',
  EQUIPMENT: 'equipment',
  SUBMITTER: 'submitter',
  FILTER_BY_DATE: 'filterByDate',
  START_DATE: 'dateRange.displayStartDate',
  END_DATE: 'dateRange.displayEndDate',
  DATE_RANGE: 'dateRange',
  MIN_PRICE: 'priceRangeMin',
  MAX_PRICE: 'priceRangeMax'
};

export const ORDERS_TO_APPROVE_COLOMN_IDS = {
  ORDER_REFERENCE_NUM: 'orderIdLink',
  ACTIONS: 'action',
  ACCOUNT: 'account',
  SUBMISSION_DATE: 'submitTime',
  EXPIRY_DATE: 'orderExpiryDate',
  SUBMITTER: 'submitterDisplayName',
  PO_NUM: 'poNumber',
  EQUIPMENT: 'equipmentSerialNumber',
  DATE_APPROVE_OR_REJECTED: 'approveTime',
  TOTAL_PRICE: 'orderTotal'
};

export const ORDERS_TO_APPROVE_TABLE_SCHEMA = [
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.ORDER_REFERENCE_NUM,
    label: 'ORDER_REFERENCE_NUMBER_FIELD',
    width: '160px',
    isFrozen: true,
    behavior: 'sortable',
    isAlwaysOn: true,
    isDisabled: true,
    isDefault: true,
    sortType: SORT_TYPE.ALPHANUMERIC
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.ACTIONS,
    width: '50px',
    isFrozen: true,
    isAlwaysOn: true
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.ACCOUNT,
    label: 'FOOTER_ACCOUNT',
    width: '170px',
    behavior: 'sortable',
    isDefault: true,
    sortType: SORT_TYPE.NUMERIC
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.SUBMISSION_DATE,
    label: 'SUBMISSION_DATE_TABLE',
    behavior: 'sortable',
    width: '128px',
    isDefault: true,
    sortType: SORT_TYPE.DATE
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.EXPIRY_DATE,
    label: 'SUMM_PAY_CARD_EXPIRATION_DATE',
    width: '128px',
    behavior: 'sortable',
    isDefault: true,
    sortType: SORT_TYPE.DATE,
    sortBy: 'unformattedOrderExpiryDate'
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.SUBMITTER,
    label: 'SUBMITTER',
    width: '190px',
    isDefault: true,
    behavior: 'sortable',
    sortType: SORT_TYPE.ALPHANUMERIC
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.PO_NUM,
    label: 'MO_PURCHASEORDER',
    width: '190px',
    behavior: 'sortable',
    sortType: SORT_TYPE.ALPHANUMERIC
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.EQUIPMENT,
    label: 'CAT_EQUIPMENT',
    width: '192px',
    behavior: 'sortable',
    sortType: SORT_TYPE.EQUIPMENT
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.DATE_APPROVE_OR_REJECTED,
    label: 'REG_BIRTHDAY_DATE',
    extendedlabel: 'BuyerApproval_Col_StatusDate',
    width: '140px',
    behavior: 'sortable',
    sortType: SORT_TYPE.DATE
  },
  {
    id: ORDERS_TO_APPROVE_COLOMN_IDS.TOTAL_PRICE,
    label: 'TOTAL_PRICE',
    width: '150px',
    behavior: 'sortable',
    isDefault: true,
    align: 'right',
    sortType: SORT_TYPE.NUMERIC,
    sortBy: 'unformattedOrderTotal'
  }
];
export const PENDING_ORDER_STATUS = '0';
export const APPROVED_ORDER_STATUS_VALUE = '1';

export const LABEL_STATUS = {
  ERRORINFO: 'errorinfo',
  WARNING: 'warning',
  DEFAULT: 'default'
};
export const SORT_BY_DATE = [
  { displayKey: 'SUBMISSION_DATE_TABLE', value: 'S' },
  { displayKey: 'SUMM_PAY_CARD_EXPIRATION_DATE', value: 'E' }
];
export const SUBMISSION_DATE = 'S';
export const ORDER_STATUS_KEYS = {
  DELETED: {
    id: '3',
    name: 'CAT_ORD_DELETED'
  },
  REJECTED: {
    id: '2',
    name: 'CAT_ORD_REJECTED'
  },
  APPROVED: {
    id: '1',
    name: 'ORG_STATUS_APPROVED'
  }
};

export const VARIANT_ORDER_STATUS = {
  DELETED: '3',
  REJECTED: '2',
  EXPIRED: '4',
  APPROVED: '1'
};

export const CONF_MODAL_ACTIONS = {
  APPROVE: 'approve',
  REJECT: 'reject',
  DELETE: 'delete'
};

export const CONF_MODAL_HEADING = {
  [CONF_MODAL_ACTIONS.APPROVE]: 'APPROVE_ORDER_CONF',
  [CONF_MODAL_ACTIONS.REJECT]: 'REJECT_ORDER_CONF',
  [CONF_MODAL_ACTIONS.DELETE]: 'DELETE_ORDER_CONF'
};

export const CONF_MODAL_MESSAGE = {
  [CONF_MODAL_ACTIONS.APPROVE]: 'APPROVE_ORDER_CONF_TEXT',
  [CONF_MODAL_ACTIONS.REJECT]: 'REJECT_ORDER_CONF_TEXT',
  [CONF_MODAL_ACTIONS.DELETE]: 'DELETE_ORDER_CONF_TEXT'
};
